const events = [
	// Checkout
	"init_checkout",
	"payment_method_selected",
	"update_checkout",
	"updated_checkout",
	"checkout_error",
	"applied_coupon_in_checkout",
	"removed_coupon_in_checkout",
	"wc_fragment_refresh",
	// Cart
	"wc_fragments_refreshed",
	"wc_fragments_loaded",
	"wc_cart_emptied",
	"wc_cart_button_updated",
	"updated_shipping_method",
	"applied_coupon",
	"removed_coupon",
	"change",
	"added_to_cart",
	"adding_to_cart",
	"removed_from_cart",
	"woocommerce_variation_has_changed",
	"updated_cart_totals",
	"applied_coupon_in_checkout",
];

export const jQueryEventsToJs = (() => {
	events.forEach((event) => {
		// Send jQuery to JS
		jQuery(document.body).on(event, (e, data) => {
			document.dispatchEvent(new CustomEvent(`${event}`, { detail: data }));
		});
	});
})();
